export const defaultConfigValues = {
  azureMapsKey: "",
  backendClientId: "",
  disablePersistQueryCache: "",
  msalAuthority: "",
  msalClientId: "",
  msalRedirectUri: "",
  msalLogLevel: "",
  sentryDsn: "",
  gitSha: "",
  sentrySampleRate: "",
  version: "development",
  systemEnvironment: "development",
  postHogKey: "",
  postHogHost: "",
  callbackPortalUrl: "https://dev.cbp.d.grewe-gruppe.de/home",
  maxInventoryPositionAgeInMinutes: 15,
  /** How long (hours) the photo-doc upload queue retries a failed upload before giving up. Default: 1 day. */
  photoDocUploadMaxRetryHours: 24,
  inventoryFirstYear: 2025,
  inventoryStartMonth: 10, // October
  inventoryStartDay: 1,
  inventoryEndMonth: 9, // September
  inventoryEndDay: 30,
};

declare global {
  interface Window {
    config: typeof defaultConfigValues;
  }
}

// Injected into index.html by Caddy in production and by the
// dev-runtime-config vite plugin locally, so it is available immediately.
export function config() {
  return window.config;
}
